export default defineNuxtRouteMiddleware(async (to) => {
  const { user, fetchMe } = useAuth()
  const bridge = useNativeBridge()

  // SSR-resolve auth for everyone. In the embed, the bridge-login redirect
  // (GET /api/auth/bridge) established a first-party probook_session BEFORE this
  // page loaded, so the cookie is present at SSR and the server renders
  // authenticated — same as a browser. No client-side auth flip → clean hydration.
  if (process.server && !user.value) {
    await fetchMe()
  }

  if (!user.value) {
    // Embed never shows /login. A missing/expired session here means the bridge
    // session lapsed; the layout emits AUTH_REQUIRED on mount so native re-runs
    // the bridge-login handshake. Let the (empty) shell render meanwhile.
    if (bridge.isNative.value) return
    // carry the intended destination so login can land the user back on it
    // (home is the default landing anyway — no param needed)
    if (to.path !== '/login') {
      return navigateTo(to.path === '/'
        ? '/login'
        : `/login?redirect=${encodeURIComponent(to.fullPath)}`)
    }
  }
  if (user.value?.needs_registration && to.path !== '/register') {
    // thread the destination through the register bounce too. same-origin only —
    // login.vue/register.vue enforce this before navigating, but a redirect param
    // should never leave the boundary carrying an off-site URL either
    const asked = typeof to.query.redirect === 'string' ? to.query.redirect : ''
    const safe = asked.startsWith('/') && !asked.startsWith('//') ? asked : ''
    const redirect = safe
      || (to.path !== '/' && to.path !== '/login' ? to.fullPath : '')
    return navigateTo(redirect ? `/register?redirect=${encodeURIComponent(redirect)}` : '/register')
  }
  if (user.value && !user.value.needs_registration && to.path === '/register') return navigateTo('/')
})
